import dynamic from 'next/dynamic';

import type { Node } from './CardConsumer';

export const CardConsumer = dynamic<{ node: Node }>(() => import('./CardConsumer').then((mod) => mod.CardConsumer));
